import styles from './Footer.module.css';
import { env  } from '../../../env';

const Footer = () => {
  return (
    <div className={styles.footerContainer}>
      <div id="footer">
        <div className={styles.footerLower}>
          <div className="footer-leadIn">
            &nbsp;<div><strong>Customer Experience </strong></div>
            <span className={styles.customerExp}>Monday - Friday, 8 a.m. - 8 p.m. ET &nbsp;</span>
            &nbsp;<a href="https://support.shrm.org/s/" target='_blank'>Contact Us</a>
          </div>
          <div className={styles.copyright}>
            &copy;&nbsp;
            <span>{new Date().getFullYear()}</span> SHRM. All rights reserved.
          </div>
          <nav>
            <ul className={styles.unstyled}>
              <li><a href={env.REACT_APP_ABOUT_PAGE.concat('privacy-policy')} target="_blank">Privacy Policy</a></li>
              <li><a href={env.REACT_APP_ABOUT_PAGE.concat('terms-of-use')} target="_blank">Terms of Use</a></li>
              <li><a href={env.REACT_APP_ABOUT_PAGE.concat('accessibility')} target="_blank">Accessibility</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Footer;
